/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_shipmentQuote = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_shipmentQuote">;
    readonly " $refType": "PdpRespShippingReturns_shipmentQuote";
};
export type PdpRespShippingReturns_shipmentQuote$data = PdpRespShippingReturns_shipmentQuote;
export type PdpRespShippingReturns_shipmentQuote$key = {
    readonly " $data"?: PdpRespShippingReturns_shipmentQuote$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespShippingReturns_shipmentQuote">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_shipmentQuote",
      "args": null
    }
  ]
};
(node as any).hash = '4838708062e93030ab0806d9793b8fff';
export default node;
